import React from 'react'
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

function RoleEquipment() {
    return (
        <SettingsMetaData propertyName={"EquipmentRole"} viewPropertyName={"Role"} />
      );
}

export default RoleEquipment